// eslint-disable-next-line no-use-before-define
import React from 'react';
import { CustomAuthProvider as CustomAuthContextProvider } from '../contexts/CustomAuthContext';

interface CustomAuthProviderProps {
  children: React.ReactNode;
}

export const CustomAuthProvider: React.FC<CustomAuthProviderProps> = ({
  children,
}) => <CustomAuthContextProvider>{children}</CustomAuthContextProvider>;
